import { Type } from 'class-transformer';

export class EntityFisicalYearResultDto {
    @Type(() => Date)
    fisicalYearBegin: Date;

    @Type(() => Date)
    fisicalYearEnd: Date;
}
